<style lang="stylus">
    .coupon
        position relative
        left 0
        top 0
        width 100vw
        height 100vh
        z-index 100

        .coupon-mask
            modal-mask()
            z-index unset

        .coupon-head
            position relative
            height 30px

            .header-close
                position absolute
                display flex
                align-items center
                justify-content center
                width 22px
                height 22px
                top 9px
                right 9px
                cursor pointer

                svg
                    width 10px
                    height 10px
        .box-btn
            display inline-block
            height 52px
            min-width 180px
            padding 0 50px
            border-radius 70px
            background #E0E0E0
            color #424242
            font-size 20px
            text-align center
            line-height 52px
            user-select none
            cursor pointer
            transition background .2s linear

            &:hover
                background #d0d0d0

            &.blue
                background #017FFF
                color #fff

                &:hover
                    background #217edc

            &.renew-btn
                background: linear-gradient(180deg, #FFD644 0%, #FF9900 100%)
                box-shadow: inset -2px -2px 4px rgba(175, 74, 0, 0.35), inset 2px 2px 4px rgba(255, 255, 255, 0.3)
                color #653000
                &:hover
                    background: linear-gradient(180deg, #FFD644 0%, #FF9900 100%)

        .coupon-box
            position absolute
            left 50%
            top 50%
            transform translateX(-50%) translateY(-50%)
            background #fff
            border-radius 4px
            box-shadow 0px 15px 40px rgba(0, 0, 0, 0.15)
            z-index 1

        .coupon-box1
            width 420px

            .coupon-box1-content
                margin 0 47px
                padding-bottom 64px
                text-align center

                &.renew-content
                    padding-bottom 74px

                .box1-title
                    margin-top 36px
                    font-size 32px
                    color #000
                    text-align center

                .box1-image
                    width 100%
                    object-fit contain
                    margin-top 52px

                .box1-content
                    text-align center
                    font-size 20px
                    margin-top 44px
                    margin-bottom 50px

                .box1-content-renew
                    text-align center
                    margin-top 16px
                    font-size 20px

            .box-count
                position absolute
                bottom 36px
                width 100%

                p
                    width 100%
                    color #333
                    font-size 16px
                    text-align center

        .coupon-box2
            width 540px

            .coupon-box2-content
                margin 0 72px
                padding-bottom 76px
                text-align center

                .box2-title
                    font-size 32px
                    color #000
                    text-align center
                    margin-top 36px

                .box2-tip
                    font-size 20px
                    color #000
                    text-align center
                    margin-top 28px

                .box2-image
                    width 218px
                    height 190px
                    margin-top 24px

                .box2-btnbox
                    display flex
                    justify-content space-between
                    margin-top 52px

                .box2-btnbox-en
                    justify-content center
                    flex-wrap wrap

                    .box-btn
                        width 100%
                        text-overflow ellipsis
                        white-space nowrap
                        overflow hidden

                    .blue
                        margin-top 20px

    .couponFrame
        border none
        width 100%
        height 100%
        max-width 640px
        max-height 435px
        position fixed
        left 50%
        top 50%
        transform translateX(-50%) translateY(-50%)
        background #fff
        border-radius 8px
        filter drop-shadow(0px 15px 40px rgba(0, 0, 0, 0.2))

    .couponFrameEN
        border none
        width 100%
        height 100%
        max-width 540px
        max-height 540px
        position fixed
        left 50%
        top 50%
        transform translateX(-50%) translateY(-50%)
        background #fff
        border-radius 8px
        filter drop-shadow(0px 15px 40px rgba(0, 0, 0, 0.2))
</style>

<template>
    <div class="coupon" v-if="showAlert">
        <div class="coupon-mask" :class="{ noMask: isPC }"></div>

        <template v-if="internal">
            <div class="coupon-box1 coupon-box" v-if="showCoupon1">
                <div class="coupon-head">
                    <div class="header-close" @click="closeBox(0)">
                        <iconSymbol name="importClose" />
                    </div>
                </div>

                <div class="coupon-box1-content" :class="{ 'renew-content': isRenew }">
                    <p class="box1-title">{{ $t("couponTitle") }}</p>
                    <p class="box1-content-renew" v-if="isRenew">{{ couponInfo.content }}</p>
                    <img class="box1-image" :src="couponInfo.img" alt="" />
                    <p class="box1-content" v-if="!isRenew">{{ couponInfo.content }}</p>
                    <div class="box-btn blue" :class="{ 'renew-btn': isRenew }" :style="isRenew ? 'margin-top:50px' : ''" @click="getCoupon">
                        {{ isRenew ? $t("renewNow") : $t("getNow") }}
                    </div>
                </div>

                <div class="box-count">
                    <p v-if="isRenew">{{ countText }}</p>
                </div>
            </div>

            <div class="coupon-box2 coupon-box" v-if="showCoupon2">
                <div class="coupon-head">
                    <div class="header-close" @click="closeBox(1)">
                        <iconSymbol name="importClose" />
                    </div>
                </div>

                <div class="coupon-box2-content">
                    <p class="box2-title">{{ $t("retainTitle") }}</p>
                    <p class="box2-tip">{{ $t("retainTip") }}</p>
                    <img class="box2-image" :src="require('@/home/assets/img/coupon-retain.svg')" alt="" />
                    <div class="box2-btnbox" :class="{ 'box2-btnbox-en': lang != 'zh' }">
                        <div class="box-btn" @click="closeBox(1)">{{ $t("leave") }}</div>
                        <div class="box-btn blue" :class="{ 'renew-btn': isRenew }" @click="getCoupon">
                            {{ isRenew ? $t("renewNow") : $t("getNow") }}
                        </div>
                    </div>
                </div>
            </div>

            <iframe class="couponFrame" v-if="showCoupon3" :src="iframeSrc" frameborder="0"></iframe>
        </template>
        <template v-else>
            <iframe class="couponFrameEN" :style="couponFrameENStyle" :src="iframeSrcEn" frameborder="0"></iframe>
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class Coupon extends Vue {
        couponInfo = {
            img: "",
            content: "",
        };
        iframeSrc = "https://www.edrawmax.cn/public/coupon/coupon.html?showHead=1";
        iframeSrcEn = "https://www.edrawsoft.com/coupon/coupon.html";
        showCoupon1 = true;
        showCoupon2 = false;
        showCoupon3 = false;

        isRenew = false; // 是否是续订弹窗
        countText = "活动倒计时 72:00:00";
        countTransText = "";
        countTimer = 0;
        maxTime = 259200;
        couponDesc = "";
        enRule = "";
        couponFrameENStyle = "";

        // en

        get userInfo() {
            return this.$store.state.userInfo;
        }
        closeBox(type) {
            if (!type) {
                // 关闭第一个弹窗
                this.showCoupon1 = false;
                this.showCoupon2 = true;
            } else {
                // 关闭第二个弹窗
                this.closeCoupon();
            }
        }

        closeCoupon() {
            // 关闭优惠券相关的弹窗
            this.$store.commit("setState", {
                type: "showCouponModal",
                data: false,
            });
            clearInterval(this.countTimer);
        }

        showCoupon() {
            // 关闭优惠券相关的弹窗
            this.$store.commit("setState", {
                type: "showCouponModal",
                data: true,
            });
        }

        initCouponData(data) {
            let userData = btoa(
                JSON.stringify({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
            );
            this.couponInfo.img = data.picture;
            this.couponInfo.content = data.content;
            this.iframeSrc = this.iframeSrc + `&coupondata=${JSON.stringify(data)}&lang=${this.lang}&user=${userData}`;

            this.maxTime = data.exp; // - Math.floor((new Date().getTime() / 1000)) + 1;
            this.startCount();
            this.countTimer = setInterval(() => {
                this.startCount();
            }, 1000);
        }

        getCoupon() {
            this.showCoupon1 = false;
            this.showCoupon2 = false;
            this.showCoupon3 = true;
            this.sensors.track("collectCoupon", {
                Catalogues: "coupon",
                type: this.couponDesc,
            });
        }

        closeCouponModal() {
            this.closeCoupon();
        }

        listenEvent(e) {
            if (e.data.type == "smartcoupon") {
                if (e.data.action == "close") {
                    this.closeCoupon();
                } else if (e.data.action == "openbuy") {
                    this.$openBuyPage();
                }
            }
        }

        startCount() {
            console.log("count");
            this.maxTime--;
            !this.countTransText && (this.countTransText = this.$t("countdown") as string);
            let hours = Math.floor(this.maxTime / 60 / 60) >= 10 ? Math.floor(this.maxTime / 60 / 60) : "0" + Math.floor(this.maxTime / 60 / 60);
            let minutes =
                Math.floor((this.maxTime / 60) % 60) >= 10 ? Math.floor((this.maxTime / 60) % 60) : "0" + Math.floor((this.maxTime / 60) % 60);
            let seconds = Math.floor(this.maxTime % 60) >= 10 ? Math.floor(this.maxTime % 60) : "0" + Math.floor(this.maxTime % 60);
            this.countText = `${this.countTransText} ${hours}:${minutes}:${seconds}`;
            if (this.maxTime == 0) clearInterval(this.countTimer);
        }

        getSmartCoupon() {
            this.$edApi
                .getSmartCoupon({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    lang: this.lang == "zh" ? "cn" : this.lang,
                })
                .then((e) => {
                    let data = e.data.data;
                    console.log("coupon", data);
                    // data = JSON.parse(`{"status":"success","data":{\"code\":\"V36X\",\"type\":0,\"value\":0.85,\"satisfy\":0,\"exp\":86400,\"product\":\"\",\"product_type\":\"\",\"title\":\"1-1-1-1\",\"content\":\"1-1-1-1\",\"picture\":\"https://www.edrawsoft.com/event/edraw-flash-sale.html?utm-campaign=EDFS-2021-ADV\",\"order_type\":1,\"chance_type\":2,\"end_time\":1634384061,\"frame_width\":540,\"frame_height\":540,\"desc\":\"activeregular 15% off coupon\",\"identity\":2,\"rule\":\"1-1-1-1\",\"pay_url\":\"https://www.edrawsoft.com/event/edraw-flash-sale.html?utm-campaign=EDFS-2021-ADV\"},"msg":null}`)
                    // data = data.data;
                    if (this.internal && data && data.chance_type && (data.chance_type == 2 || data.chance_type == 3)) {
                        this.sensors.track("popCoupon", {
                            Catalogues: "coupon",
                            type: data.desc,
                        });
                        this.couponDesc = data.desc;
                        this.isRenew = data.order_type == 2;
                        this.initCouponData(data);
                        this.readSmartCoupon(data.code);
                        this.showCoupon();
                    } else if (data) {
                        // en
                        this.enRule = data.rule;
                        if (data.frame_height && data.frame_width) {
                            this.couponFrameENStyle = `max-height:${data.frame_height}px;max-width:${data.frame_width}px`;
                        }
                        if (data.chance_type == 2) {
                            this.showCouponEN(true);
                            this.enRule = null;
                        }
                    }
                });
        }

        readSmartCoupon(code) {
            console.log("read");
            this.$edApi
                .readSmartCoupon({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    code,
                })
                .then((res) => {});
        }
        getShowRule(rule) {
            console.log("check rule");
            let couponRules: any = localStorage.getItem("couponRules"); // 当前生效rule
            let getDayInterval = (data) => {
                // 获取间隔天数
                let nowDateTime = new Date(new Date().toLocaleDateString()).getTime();
                let oldDateTime = new Date(new Date(data).toLocaleDateString()).getTime();
                if (nowDateTime < oldDateTime) return 0;
                return Math.floor((nowDateTime - oldDateTime) / (24 * 60 * 60 * 1000));
            };
            let dayFunc = (dayCount, ruleArr, alertCount, totalCount) => {
                // 根据天数规则判断是否弹出
                let day = getDayInterval(dayCount);
                if (dayCount && day < ruleArr[1]) {
                    if (totalCount == ruleArr[3]) {
                        // 弹出次数限制,等待下次循环
                        return "max";
                    }
                    if (alertCount + 1 >= ruleArr[2]) {
                        // 间隔次数满足条件,显示弹窗
                        return "show";
                    } else {
                        // 间隔次数不满足条件,不显示弹窗,间隔次数+1
                        return "add";
                    }
                } else {
                    // 清零间隔次数,显示弹窗
                    return "reset";
                }
            };
            let startFunc = (startCount, ruleArr, alertCount, totalCount) => {
                if (startCount && startCount < ruleArr[1]) {
                    if (totalCount == ruleArr[3]) {
                        // 弹出次数限制,等待下次循环
                        return "max";
                    }
                    if (alertCount + 1 >= ruleArr[2]) {
                        // 间隔次数满足条件,显示弹窗
                        return "show";
                    } else {
                        // 间隔次数不满足条件,不显示弹窗,间隔次数+1
                        return "add";
                    }
                } else {
                    // 清零间隔次数,显示弹窗
                    return "reset";
                }
            };
            let getLocal = () => {
                if (couponRules) {
                    for (let i of couponRules) {
                        if (i.id == this.userInfo.user_id) {
                            return i;
                        }
                    }
                }
                return null;
            };
            let setLocal = (obj) => {
                let index = -1;
                if (couponRules) {
                    for (let i = 0; i < couponRules.length; i++) {
                        if (couponRules[i].id == this.userInfo.user_id) {
                            Object.assign(obj, {
                                id: this.userInfo.user_id,
                            });
                            index = i;
                            couponRules.splice(i, 1, obj);
                            break;
                        }
                    }
                } else {
                    couponRules = [];
                }
                if (index == -1) {
                    Object.assign(obj, {
                        id: this.userInfo.user_id,
                    });
                    couponRules.push(obj);
                }
                localStorage.setItem("couponRules", JSON.stringify(couponRules));
            };
            if (couponRules) {
                couponRules = JSON.parse(couponRules);
            }
            let couponRule = getLocal();
            let action = "";
            let startCount = 0,
                dayCount = 0,
                alertCount = 0,
                totalCount = 0,
                oldRule = "";
            if (couponRule) {
                (startCount = Number(couponRule.startCount)),
                    (dayCount = couponRule.dayCount),
                    (alertCount = Number(couponRule.alertCount)),
                    (totalCount = Number(couponRule.totalCount)),
                    (oldRule = couponRule.oldRule);
                if (oldRule == rule) {
                    let ruleArr = rule.split("-").map((v) => Number(v));
                    if (ruleArr[0] == "0") {
                        return true;
                    } else if (ruleArr[0] == "1") {
                        action = dayFunc(dayCount, ruleArr, alertCount, totalCount);
                    } else if (ruleArr[0] == "2") {
                        // 暂时不用启动次数
                        // action = startFunc(startCount, ruleArr, alertCount, totalCount);
                        action = dayFunc(dayCount, ruleArr, alertCount, totalCount);
                    }
                } else {
                    action = "reset";
                }
            } else {
                action = "reset";
            }
            switch (action) {
                case "max":
                    return false;
                case "show":
                    setLocal({
                        startCount,
                        dayCount,
                        alertCount: 1,
                        totalCount: totalCount + 1,
                        oldRule,
                    });
                    return true;
                case "add":
                    setLocal({
                        startCount,
                        dayCount,
                        alertCount: alertCount + 1,
                        totalCount,
                        oldRule,
                    });
                    return false;
                case "reset":
                    setLocal({
                        startCount: 0,
                        dayCount: new Date(new Date().toLocaleDateString()).getTime(),
                        alertCount: 0,
                        totalCount: 1,
                        oldRule: rule,
                    });
                    return true;
            }
        }

        showCouponEN(forceShow = false) {
            if (!this.userInfo || !this.enRule) {
                return;
            }
            let userData = btoa(
                JSON.stringify({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
            );
            let isShow = forceShow ? true : this.getShowRule(this.enRule);
            this.iframeSrcEn = "https://www.edrawsoft.com/coupon/coupon.html" + `?user=${userData}&lang=${this.lang}`;
            console.log(isShow);
            isShow && this.showCoupon();
        }

        get showAlert() {
            console.log("showalert", this.delayDone, this.$store.state.showCouponModal, ["/", "new"].includes(this.$route.name));
            return this.delayDone && this.$store.state.showCouponModal && ["/", "new"].includes(this.$route.name);
        }

        delayDone = true;
        setDelay(time) {
            console.log("setdelay", time);
            if (time != -1) {
                setTimeout(() => {
                    this.delayDone = true;
                }, time * 1000);
            }
            this.delayDone = false;
        }

        created() {
            if (this.$store.state.initLang) {
                !this.isPC && this.getSmartCoupon();
            } else {
                this.$bus.$on("firstSetLang", () => {
                    !this.isPC && this.getSmartCoupon();
                });
            }
            // if(this.userInfo){
            //     if(!this.params.islogin){
            //         return;
            //     }
            //     !this.isPC && this.getSmartCoupon()
            // }else{
            //     this.$bus.$on("loginSucc",()=>{
            //         !this.isPC && this.getSmartCoupon()
            //     })
            // };
            if (!this.internal) {
                this.$bus.$on("showCouponEN", () => {
                    this.showCouponEN();
                });
            }
            this.$bus.$on("delayAlert", this.setDelay);
            window.addEventListener("message", this.listenEvent);
        }

        beforeDestroy() {
            window.removeEventListener("message", this.listenEvent);
            this.$bus.$off("showCouponEN");
            this.$bus.$off("delayAlert", this.setDelay);
        }
    }
</script>
<i18n>
{
  "zh": {
    "couponTitle": "福利大放送",
    "retainTitle": "专享优惠限时生效",
    "retainTip": "离开优惠即将作废，确定要离开吗？",
    "getNow": "立即领取",
    "renewNow": "立即续订",
    "leave": "残忍离开",
    "countdown": "活动倒计时"
  },
  "en": {
    "couponTitle": "Limited Time Offer",
    "retainTitle": "Don't Miss Out…",
    "retainTip": "This special offer is only available on this page. Are you sure you want to leave?",
    "getNow": "Get it now",
    "renewNow": "Renew now",
    "leave": "Leave this page",
    "countdown": "Ends on: "
  },
  "fr": {
    "tip": "Indice",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "tip": "Hinweis"
  },
  "jp": {
    "confirm": "OK",
    "cancel": "キャンセル",
    "tip": "ご注意"
  },
  "es": {
    "tip": "Consejo",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "pt": {
    "tip": "Ponta",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "tip": "Suggerimento",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "tip": "提示",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "couponTitle": "한시적 혜택",
    "retainTitle": "혜택이 제한적으로 적용됩니다",
    "retainTip": "이 특별 할인은 이 페이지에서만 제공됩니다. 정말떠나겠습니까?",
    "getNow": "지금 수령",
    "renewNow": "지금 주문 연장",
    "leave": "이 페이지에서 나가기",
    "countdown": "이벤트 끝 날짜:"
  },
  "id": {
    "couponTitle": "Penawaran dengan Waktu Terbatas",
    "retainTitle": "Jangan Lewatkan ....",
    "retainTip": "Penawaran spesial ini hanya tersedia pada halaman ini. Yakin ingin keluar?",
    "getNow": "Dapatkan sekarang",
    "renewNow": "Perpanjang sekarang",
    "leave": "Tinggalkan halaman ini",
    "countdown": "Berakhir pada: "
  }
}
</i18n>
